import { AsButton, AsLabel, AsText, Spacer, useModal, getClaimValue } from '@adserve/adserve-react-components';
import React, { useState, useEffect } from 'react';
import RichTextEditor from '../../../generic/RichTextEditor/RichTextEditor';

// ASSP-8023 Lighter font used elsewhere - allows rich text bold to show clearly
//
export const fontStyle = {
  fontFamily: "Roboto, Arial, sans-serif",
  letterSpacing: 0,
  fontWeight: 400,
  color: '#414141',
};

const headingStyle = {
    ...fontStyle,
    fontWeight: 450,
};

// ASSP-8023 Read-only note viewer - requires updated read-only RichTextEditor
//
const CampaignViewNote = ({ note = {} }) => {
    const { removeMessage } = useModal();

    const handleClose = () => {
        removeMessage();
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div><h1 style={headingStyle}>Viewing Note</h1></div>
            <Spacer height={10} />
            <div style={{ width: '33%', ...fontStyle }}>{note?.name}</div>
            <Spacer height={20} />
            <div style={{ width: '65%', ...fontStyle }}>{note?.description}</div>
            <Spacer height={29} />
            <div style={{ height: 200, ...fontStyle }}>
                <RichTextEditor value={note?.value} readOnly />
            </div>
            <Spacer height={49} />
            <div style={{ display: 'flex', justifyContent: 'flex-end'}}>
                <AsButton
                    style={{
                        height: 34,
                        fontSize: 15,
                        width: 'max-content',
                        padding: '0 10px',
                        minWidth: 84
                    }}
                    useTertiaryStyle
                    handleClick={handleClose}
                >
                    {window.translate('Close')}
                </AsButton>
            </div>
        </div>
    );
};

export default CampaignViewNote;
